import { LoanerOrRentalOption } from '../../API/Enums';
import { GoMotoFunction } from '../../API/GoMoto.types';
import { useLocalization } from '../../context/Localization/localization';
import { LoanerOrRentalLocalizationTextProps, LoanerOrRentalLocalizationTextReturn } from './useLoanerOrRentalLocalizationText.types';

export const useLoanerOrRentalLocalizationText: GoMotoFunction<[LoanerOrRentalLocalizationTextProps], LoanerOrRentalLocalizationTextReturn> = ({
    loanerOrRentalOption,
}) => {
    const Localization = useLocalization();

    switch (loanerOrRentalOption) {
        case LoanerOrRentalOption.Both:
            return {
                headerText: Localization.LoanerAndRentalReturn,
                instructionText: Localization.LoanerOrRental.toLowerCase(),
            };
        case LoanerOrRentalOption.Loaners:
            return {
                headerText: Localization.LoanerReturn,
                instructionText: Localization.Loaner.toLowerCase(),
            };
        case LoanerOrRentalOption.Rentals:
            return {
                headerText: Localization.RentalReturn,
                instructionText: Localization.Rental.toLowerCase(),
            };
        default:
            return {
                headerText: undefined,
                instructionText: undefined,
            };
    }
};